var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-link-list"},_vm._l((_vm.groups),function(group,index){return _c('SrLinkListGroup',{key:index,attrs:{"group":group}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }